/**
 * @description Check if the client has capabilities on `channels`
 */
export function hasCapability(auth, channels, capabilityValidatorFunc) {
  try {
    if (!auth.tokenDetails || auth.tokenDetails && auth.tokenDetails.expires < Date.now()) {
      return false;
    }
    const capability = JSON.parse(auth.tokenDetails.capability);
    if (capabilityValidatorFunc) {
      return capabilityValidatorFunc(Object.keys(capability), channels);
    }
    const capabilityPatterns = Object.keys(capability);
    return anyChannelMatches(channels, capabilityPatterns);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('hasCapability check failed', e);
    return false;
  }
}
function anyChannelMatches(requestedChannels, capabilityPatterns) {
  return requestedChannels.every(channel => capabilityPatterns.some(pattern => {
    if (!pattern.includes('*')) {
      // Fast path for exact matches (no wildcards) for performance
      return channel === pattern;
    }
    return getAblyPatternAsRegex(pattern).test(channel);
  }));
}

/**
 * Ably supports '*' wildcard chars so "thread:v2:qa:*:893587399:1227314693:*" will match
 *  "thread:v2:qa:shared:893587399:1227314693:11581d60-c867-4235-b957-82a23e24bac7"
 * To replicate this, we turn the given ably channel pattern into a regex but escape all special chars
 * and then replace * at beginning/end with .* (matches everything) and * elsewhere with [^:]* (matches one segment)
 * See https://ably.com/docs/auth/capabilities#wildcards
 */
function getAblyPatternAsRegex(pattern) {
  // Replace all special regex starts except * with their escaped version so they won't interfere with matching
  const escapedPattern = pattern.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');

  // The first * and last * will match any number of sections, but the middle * should not.
  // I.e. "apple:bat:cat:dog" will match with "*:dog" but not "apple:*:dog"
  const regex = escapedPattern.replace(/(.)\*(.)/g, `$1[^:]*$2`) // Middle * only (Replace every * with [^:]* except if that * is the first or last character)
  .replace(/^\*/, '.*') // Start * (replace with .* so it will cross sections)
  .replace(/\*$/, '.*'); // End * (replace with .* so it will cross sections)

  return new RegExp(`^${regex}$`);
}